import { createSelector } from "reselect";

const selectState = (state) => state.pasture;

export const selectMode = createSelector(selectState, (state) => state.mode);
